/*
 * @Author: luyaj 1579618152@qq.com
 * @Date: 2025-03-13 20:02:29
 * @LastEditors: luyaj 1579618152@qq.com
 * @LastEditTime: 2025-12-22 20:33:48
 * @FilePath: \my-vue-project\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/homeInfo/about',
    name: 'homeInfoAboutUs',
    component: () => import('@/views/homeInfo/AboutUs.vue'),
  },
  // 新添加的“联系我们”页面路由
  {
    path: '/homeInfo/contact',
    name: 'homeInfoContactUs',
    component: () => import('@/views/homeInfo/ContactUs.vue'),
  },
  {
    path: '/homeInfo/copyright',
    name: 'homeInfoCopyrightDisclaimer',
    component: () => import('@/views/homeInfo/CopyrightDisclaimer.vue'),
  },
  {
    path: '/homeInfo/design',
    name: 'homeInfoDesignSpecifications',
    component: () => import('@/views/homeInfo/DesignSpecifications.vue'),
  },
  {
    path: '/society',
    component: () => import('@/views/SocietyLayout'),
    children: [
      { path: '/society/about', component: () => import('@/views/society/AboutView') },
      { path: '/society/bylaws', component: () => import('@/views/society/BylawsView') },
      { path: '/society/council', component: () => import('@/views/society/CouncilView') },
      { path: '/society/members/:id', component: () => import('@/views/society/MemberDetailView'), props: true },
      { path: '/society/members', component: () => import('@/views/society/MembersView') },
      { path: '/society/collection/:id', component: () => import('@/views/society/CollectionDetailView'), props: true },
      { path: '/society/collection', component: () => import('@/views/society/CollectionView') },
      { path: '/society/notices', component: () => import('@/views/society/NoticesView') }
    ]
  },
  {
    path: '/highQuality/index',
    component: () => import('@/views/highQuality/highQuality.vue'),
  },
  {
    path: '/highQuality/:msgType',
    name: 'highQuality',
    component: () => import('@/views/highQuality/highQualityLayout.vue'),
  },
  {
    path: '/highQuality/:msgType/detail/:id',
    name: 'highQualityDetail',
    component: () => import('@/views/highQuality/highQualityLayout.vue'),
    props: true
  },
  {
    path: '/industryIntroduction/index',
    component: () => import('@/views/industryIntroduction/industryIntroduction.vue'),
  },
  {
    path: '/industryIntroduction/:msgType',
    name: 'industryIntroduction',
    component: () => import('@/views/industryIntroduction/industryIntroductionLayout.vue'),
  },
  {
    path: '/master/index',
    name: 'masterGather',
    component: () => import('@/views/master/masterGather.vue'),
  },
  {
    path: '/master/detail/:msgType/:id',
    name: 'masterDetail',
    component: () => import('@/views/master/masterDetail.vue'),
  },
  {
    path: '/masterHighQuality/index',
    redirect: (to) => {
      if (to.query.msgType && to.query.name) {
        return `/masterHighQuality/${to.query.msgType}/${encodeURIComponent(to.query.name)}`
      }
      return '/'
    },
  },
  {
    path: '/masterHighQuality/:msgType/:name',
    name: 'masterHighQualityCategory',
    component: () => import('@/views/master/masterHighQualityGather.vue'),
  },
  {
    path: '/masterHighQuality/detail/:name/:msgType/:id',
    name: 'masterHighQualityDetail',
    component: () => import('@/views/master/masterHighQualityDetail.vue'),
  },
  {
    path: '/heritage/index',
    name: 'heritageGather',
    component: () => import('@/views/heritage/heritageGather.vue'),
  },
  {
    path: '/heritage/detail/:msgType/:id',
    name: 'heritageDetail',
    component: () => import('@/views/heritage/heritageDetail.vue'),
  },
  {
    path: '/newsNotice/index',
    name: 'newsNotice',
    component: () => import('@/views/newsNotice/newsNoticeGather.vue'),
  },
  {
    path: '/exhibition/folk-craft',
    name: 'folkCraftExhibition',
    component: () => import('@/views/exhibition/folkCraft2026.vue'),
  },
  {
    path: '/newsNotice/detail/:id',
    name: 'newsNoticeDetail',
    component: () => import('@/views/newsNotice/newsNoticeDetail.vue'),
  },
  {
    path: '/interviews/index',
    name: 'interviews',
    component: () => import('@/views/interviews/interviewsGather.vue'),
  },
  {
    path: '/interviews/detail/:id',
    name: 'interviewsDetail',
    component: () => import('@/views/interviews/interviewsDetail.vue'),
  },
  {
    path: '/research/index',
    name: 'research',
    component: () => import('@/views/research/researchGather.vue'),
  },
  {
    path: '/research/detail/:id',
    name: 'researchDetail',
    component: () => import('@/views/research/researchDetail.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
